import React, { useState } from 'react';
import clinicService from '../../../../../services/clinic.service';
import { toast } from 'react-toastify';
import { useForm } from 'react-hook-form';
function AddLinksForm({ clinicid, getLinks, onCancel, existingLinks }) {
    const { register, handleSubmit, formState: { errors }, reset } = useForm();
    const [isSubmitting, setIsSubmitting] = useState(false);

    const getUsedPlatforms = () => {
        if (!existingLinks || !Array.isArray(existingLinks)) return [];
        return existingLinks.map((link) => link.linkType);
    };

    const usedPlatforms = getUsedPlatforms();

    const platformOptions = [
        { value: 'FACEBOOK', label: 'Facebook' },
        { value: 'WEBSITE', label: 'Website' },
        { value: 'INSTAGRAM', label: 'Instagram' },
        { value: 'GOOGLE', label: 'Google' },
        { value: 'YELP', label: 'Yelp' },
    ];

    const availablePlatforms = platformOptions.filter((platform) => !usedPlatforms.includes(platform.value));

    const onSubmit = (data) => {
        setIsSubmitting(true);
        clinicService
            .addUpdateReputationLink(clinicid, data)
            .then(() => {
                getLinks();
                reset();
                onCancel?.();
                toast.success('Link added successfully', { position: toast.POSITION.BOTTOM_RIGHT });
            })
            .catch(() => {
                toast.error('Error adding link. Please try again.', { position: toast.POSITION.BOTTOM_RIGHT });
            })
            .finally(() => {
                setIsSubmitting(false);
            });
    };

    return (
        <div className="border rounded p-3 bg-light">
            <div className="notifications-form-label mb-3">
                <i className="bi bi-plus-circle me-1"></i>
                Add New Reputation Link
            </div>
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="row g-3">
                    <div className="col-md-6">
                        <label htmlFor="linkType" className="notifications-form-label">
                            Platform
                        </label>
                        <select
                            id="linkType"
                            className={`form-select form-select-sm ${errors.linkType ? 'is-invalid' : ''}`}
                            {...register('linkType', { required: 'Platform is required' })}
                            disabled={isSubmitting || availablePlatforms.length === 0}
                        >
                            <option value="">Select a platform</option>
                            {availablePlatforms.map((platform) => (
                                <option key={platform.value} value={platform.value}>
                                    {platform.label}
                                </option>
                            ))}
                        </select>
                        {errors.linkType && <div className="invalid-feedback">{errors.linkType.message}</div>}
                        {availablePlatforms.length === 0 && (
                            <div className="notifications-form-hint text-warning">All available platforms have been added.</div>
                        )}
                    </div>

                    <div className="col-md-6">
                        <label htmlFor="link" className="notifications-form-label">
                            URL
                        </label>
                        <input
                            type="text"
                            id="link"
                            className={`form-control form-control-sm ${errors.link ? 'is-invalid' : ''}`}
                            placeholder="https://example.com"
                            disabled={isSubmitting}
                            {...register('link', {
                                required: 'URL is required',
                                pattern: {
                                    value: /^(https?:\/\/)/,
                                    message: 'URL must start with http:// or https://',
                                },
                            })}
                        />
                        {errors.link && <div className="invalid-feedback">{errors.link.message}</div>}
                        <input type="hidden" {...register('clinicId')} value={clinicid} />
                    </div>

                    <div className="col-md-6">
                        <label htmlFor="notes" className="notifications-form-label">
                            Notes
                        </label>
                        <input type="text" id="notes" className="form-control form-control-sm" placeholder="Optional notes" disabled={isSubmitting} {...register('notes')} />
                    </div>

                    <div className="col-md-6">
                        <label htmlFor="extraData" className="notifications-form-label">
                            Extra Data
                        </label>
                        <input type="text" id="extraData" className="form-control form-control-sm" placeholder="Optional extra data" disabled={isSubmitting} {...register('extraData')} />
                    </div>

                    <div className="col-md-6">
                        <label htmlFor="isActive" className="notifications-form-label">
                            Status
                        </label>
                        <select id="isActive" className="form-select form-select-sm" disabled={isSubmitting} {...register('isActive')}>
                            <option value="true">Active</option>
                            <option value="false">Inactive</option>
                        </select>
                    </div>
                </div>

                <div className="reputation-form-actions">
                    {onCancel && (
                        <button type="button" className="btn btn-outline-secondary btn-sm" onClick={onCancel} disabled={isSubmitting}>
                            Cancel
                        </button>
                    )}
                    <button type="submit" className="btn btn-success btn-sm" disabled={isSubmitting || availablePlatforms.length === 0}>
                        {isSubmitting ? (
                            <>
                                <span className="spinner-border spinner-border-sm me-1" role="status"></span>
                                Saving…
                            </>
                        ) : (
                            <>
                                <i className="bi bi-floppy me-1"></i>
                                Save Link
                            </>
                        )}
                    </button>
                </div>
            </form>
        </div>
    );
}

export default AddLinksForm;
